import React from 'react';
import { get, map } from 'lodash';
import classnames from 'classnames';
import { Icon } from 'modules/icon-bank';

//local dependencies
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { entityInfoCells as EntityInfoCells } from 'ui/views/widgets/entityInfoCells';
import { getLabel } from 'utils/getLabel';

// group action view
export const DetailSummaryAction = ( props ) => {

    // action item class name
    const widgetClassName = classnames( 'ui-table__body__data__row__primary__cell__actions__item', {
        'ui-table__body__data__row__primary__cell__actions__item--disabled': ! props.isActive,
    } );

    // get `hideIfDisabled` from action config
    // const hideIfDisabled = get( props, 'action.config.hideIfDisabled', false );

    // return null if action is not active and `hideIfDisabled`: true
    if( ! props.isActive ) {
        return null;
    }

    return (
        <div className={ widgetClassName } onClick={ () => props.onClick( { type: 'headerAction', value: props.action } ) }>
            <div className='ui-table__body__data__row__primary__cell__actions__item__icon'>
                <Icon
                    name={ props.iconName }
                    width={ 20 }
                    height={ 20 }
                    fill={ props.isActive ? THEME.themeColorPrimary2 : '#7a7a7a' }
                />
            </div>

            <div className='ui-table__body__data__row__primary__cell__actions__item__title'>
                { getLabel( props.action.title ) }
            </div>
        </div>
    );
};

// set display name
DetailSummaryAction.displayName = '_memberOrderDetailSummary.DetailSummaryAction';
 
/** *************************** */

const NAV_ACTION_ICON = {
    'edit': 'edit',
    'reorder': 'reorder',
    'cancelOrder': 'cancelOrder',
    'todos': 'checkedContent',
    'notes': 'callNotes',
    'markResolved': 'checkedCircle'
};

/**
 * @desc: member detail summary view
 */
const _memberOrderDetailSummary = ( props ) => {

    const primarySection = get( props, 'componentData.primarySection', [] );
    const secondarySection = get( props, 'componentData.secondarySection', [] );
    const widgetTitle = get( props, 'componentData.widgetConfig.title', [] );
    const orderData = get( props, 'componentData.orderData', {} );
    const navActions = get( props, 'componentData.navActions', {} );

    return (
        <div className='ui-member-order-detail-summary'>
            
            {/* widget title */}
            <div className='ui-member-order-detail-summary__header'>
                <div className='ui-member-order-detail-summary__header__title'>
                    { getLabel( widgetTitle ) }
                </div>
                
                <div className='ui-member-order-detail-summary__header__actions'>
                    { map( navActions, action => {

                        // get if the action is active or not
                        const isActive = get( orderData, `actionsVisibility.${ action.visibility }`, false );

                        // get action icon
                        const iconName = NAV_ACTION_ICON[ `${ action.name }` ];

                        return (
                            <DetailSummaryAction
                                key={ action.name }
                                action={ action }
                                isActive={ isActive }
                                iconName={ iconName }
                                onClick={ props.onActionClick }
                            />
                        );

                    } ) }
                </div>

                {/* widget - action */}

                {/* live status refresh */}
                <div className='ui-member-order-detail-summary__header__live-status' aria-live='polite' aria-atomic='true'>
                    <button
                        className={ `ui-member-order-detail-summary__header__live-status__button${ props.isCheckingLiveStatus ? ' ui-member-order-detail-summary__header__live-status__button--checking' : '' }` }
                        onClick={ props.onCheckLiveStatus }
                        disabled={ props.isCheckingLiveStatus }
                    >
                        { props.isCheckingLiveStatus ? 'Checking…' : 'Check current status' }
                    </button>
                    { props.liveStatusAsOf && ! props.liveStatusError && (
                        <span className='ui-member-order-detail-summary__header__live-status__timestamp'>
                            { `Live as of ${ new Date( props.liveStatusAsOf ).toLocaleString() }` }
                        </span>
                    ) }
                    { props.liveStatusError === 'FETCH_FAILED' && (
                        <span className='ui-member-order-detail-summary__header__live-status__error'>
                            Unable to fetch live status &mdash; try again
                        </span>
                    ) }
                    { props.liveStatusError === 'STATUS_UNAVAILABLE' && (
                        <span className='ui-member-order-detail-summary__header__live-status__error'>
                            Status unavailable
                        </span>
                    ) }
                </div>

            </div>
            <div className='ui-member-order-detail-summary__body'>
                <div className='ui-member-order-detail-summary__body__primary'>

                    {/* view to render order details */}
                    <EntityInfoCells
                        items= { primarySection }
                        values={ orderData.values }
                        actionsVisibility = { orderData.actionsVisibility }
                        iconsVisibility = { orderData.iconsVisibility }
                        onActionClick={ props.onActionClick }
                        className='ui-member-order-detail-summary__body__primary__cell'
                    />

                </div>
                <div className='ui-member-order-detail-summary__body__secondary'>
                    
                    <EntityInfoCells
                        items= { secondarySection }
                        values={ orderData.values }
                        actionsVisibility = { orderData.actionsVisibility }
                        onActionClick={ props.onActionClick }
                        className='ui-member-order-detail-summary__body__secondary__cell'
                    />

                </div>
                
            </div>
        </div>
    );
};

// set display name
_memberOrderDetailSummary.displayName = 'memberOrderDetailSummary';

// set default props
_memberOrderDetailSummary.defaultProps = {};

// prop types
_memberOrderDetailSummary.propTypes = {};

/* ********************** */

export const memberOrderDetailSummaryPreloader = ( ) => {
   
    return (
        <div className='ui-member-order-detail-summary-preloader'>
            <div className='ui-member-order-detail-summary-preloader__header'>
                <div className='ui-member-order-detail-summary-preloader__header__title'></div>
                <div className='ui-member-order-detail-summary-preloader__header__actions'>
                    { map( [ 1, 2, 3 ], item => {
                        return (
                            <div className='ui-member-order-detail-summary-preloader__header__actions__action' key={ item } ></div>
                        );
                    } ) }
                </div>
            </div>
            <div className='ui-member-order-detail-summary-preloader__body'>
                { map( [ 1, 2 ], item => {
                    return (
                        <div className='ui-member-order-detail-summary-preloader__body__primary' key={ item }>
                            { map( [ 1, 2, 3, 4, 5, 6 ], _item => {
                                return (
                                    <div  className='ui-member-order-detail-summary-preloader__body__primary__cell' key={ _item }>
                                        <div className='ui-member-order-detail-summary-preloader__body__primary__cell__title'></div>
                                        <div className='ui-member-order-detail-summary-preloader__body__primary__cell__value'></div>
                                    </div>
                                );
                            } ) }
                        </div>
                    );
                } ) }
            </div>
        </div>
    );
};

// set display name
memberOrderDetailSummaryPreloader.displayName = 'memberOrderDetailSummaryPreloader';

// set default props
memberOrderDetailSummaryPreloader.defaultProps = {};

// prop types
memberOrderDetailSummaryPreloader.propTypes = {};

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { memberOrderDetailSummary as MemberOrderDetailSummary } from 'ui/views/widgets/memberOrderDetailSummary';
 *
 * // render
 * <MemberOrderDetailSummary propName='propValue'/>
 */
export const memberOrderDetailSummary = withNetworkState( memberOrderDetailSummaryPreloader, _memberOrderDetailSummary );

